(() => {
  'use strict';

  const ACTIVE_CLASS = 'vc-tactile-feedback';
  const timers = new WeakMap();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

  const readCleanupDuration = (element) => {
    const value = getComputedStyle(element).getPropertyValue('--vc-tactile-cleanup').trim();
    if (value.endsWith('ms')) return Number.parseFloat(value) || 340;
    if (value.endsWith('s')) return (Number.parseFloat(value) || 0.34) * 1000;
    return Number.parseFloat(value) || 340;
  };

  const clear = (element) => {
    if (!(element instanceof Element)) return;
    const timer = timers.get(element);
    if (timer) clearTimeout(timer);
    timers.delete(element);
    element.classList.remove(ACTIVE_CLASS);
  };

  const play = (element) => {
    if (!(element instanceof Element) || reducedMotion.matches) return false;
    clear(element);
    void element.offsetWidth;
    element.classList.add(ACTIVE_CLASS);
    timers.set(element, setTimeout(() => clear(element), readCleanupDuration(element)));
    return true;
  };

  window.VelveleTactileFeedback = Object.freeze({
    activeClass: ACTIVE_CLASS,
    clear,
    play
  });
})();
